import { render } from "./DBFUploading.vue?vue&type=template&id=b9714486&ts=true"
import script from "./DBFUploading.vue?vue&type=script&lang=ts"
export * from "./DBFUploading.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__